import { render, staticRenderFns } from "./TenancyDocumentRemarks.vue?vue&type=template&id=56254697&scoped=true&"
import script from "./TenancyDocumentRemarks.vue?vue&type=script&lang=js&"
export * from "./TenancyDocumentRemarks.vue?vue&type=script&lang=js&"
import style0 from "./TenancyDocumentRemarks.vue?vue&type=style&index=0&id=56254697&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56254697",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56254697')) {
      api.createRecord('56254697', component.options)
    } else {
      api.reload('56254697', component.options)
    }
    module.hot.accept("./TenancyDocumentRemarks.vue?vue&type=template&id=56254697&scoped=true&", function () {
      api.rerender('56254697', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/view/TenancyDocumentRemarks.vue"
export default component.exports